import axios from "axios";
import adminAxiosInstance from "./api/adminAxiosInstance";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const login = async (email, password, ipaddress) => {
    const response = await axios.post(`${BASE_URL}admin/login`, { email, password, ipaddress });
    return response.data; 
};

const getAdminByEmail = async (email) => {
    const response = await adminAxiosInstance.get(`admin/by-email/${email}`);
    return response.data;
};

const impersonateClient = async (clientId) => {
    const response = await adminAxiosInstance.post(`admin/impersonate/${clientId}`);
    return response.data;
};

export const authAdminService = {
    login,
    getAdminByEmail,
    impersonateClient
};